document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".category-breadcrumbs-slider");

  sliders.forEach(slider => {
    const active = slider.querySelector(".category-breadcrumb.active-link");

    if (active) {
      active.scrollIntoView({
        inline: "start",
        behavior: "smooth",
        block: "nearest"
      });
    }
  });
});
